import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import data from "../data/April_16_Test_Result.json";
import { useNavigate } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import { Divider } from "@mui/material";

const ResultPage = () => {
  const { phoneNumber, dob } = useParams();
  const navigate = useNavigate();
  const [studentData, setStudentData] = React.useState();
  const [showGif, setShowGif] = React.useState(false);

  React.useEffect(() => {
    const studentData = data.filter(
      (d) => d.phNo === phoneNumber && d.dob === dob
    );
    if (studentData[0]?.phNo === phoneNumber && studentData[0]?.dob === dob) {
      setStudentData(studentData);
      if (
        studentData[0]?.rank === "1" ||
        studentData[0]?.rank === "2" ||
        studentData[0]?.rank === "3" ||
        studentData[0]?.rank === "1-A" ||
        studentData[0]?.rank === "1-B"
      ) {
        setShowGif(true);
      } else {
        setShowGif(false);
      }
    } else {
      navigate("/download");
    }
  }, [dob, phoneNumber, navigate, setStudentData]);
  return (
    <Container sx={{ marginTop: "100px", marginBottom: "25px" }}>
      {studentData && (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              mb: 5,
            }}
          >
            <Typography variant="h4">
              <center>Welcome </center>
              <br />
              {showGif && (
                <>
                  <center>
                    <img
                      src="/GIF/Congrats.gif"
                      alt="Congratulations"
                      style={{
                        width: "10rem",
                        height: "10rem",
                        borderRadius: "50%",
                      }}
                    />
                  </center>
                  <br />
                </>
              )}
              <center style={{ fontWeight: "600" }}>
                {studentData[0].name}
              </center>
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "column",
                boxShadow: "#dad2cb 12px 12px 24px",
                border: "2px solid black",
                borderRadius: "25px",
                width: "40rem",
                padding: "0.5rem",
              }}
            >
              <table style={{ width: "100%" }}>
                <tr>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "400" }}>
                      Rank
                    </Typography>
                  </td>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "600" }}>
                      {studentData[0].rank}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "400" }}>
                      Obtained Marks
                    </Typography>
                  </td>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "600" }}>
                      {studentData[0].marks}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "400" }}>
                      Class
                    </Typography>
                  </td>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "600" }}>
                      {studentData[0].studentClass}th
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "400" }}>
                      Contact Number
                    </Typography>
                  </td>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "600" }}>
                      {studentData[0].phNo}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "400" }}>
                      DOB
                    </Typography>
                  </td>
                  <td>
                    <Typography variant="h5" sx={{ fontWeight: "600" }}>
                      {studentData[0].dob}
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                  <td>
                    <Divider
                      sx={{
                        height: "2px",
                        backgroundColor: "#665b5b",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    />
                  </td>
                </tr>
              </table>
            </Grid>
          </Box>
        </>
      )}
    </Container>
  );
};

export default ResultPage;
